(function () {
    'use strict';

    var $ = window.jQuery;

    function BossButton() {
        $(document).on('click', '[data-toggle="show-boss-button-overlay"]', function (e) {
            e.preventDefault();
            $('body').addClass('show-boss-button-overlay');
            return false;
        });

        $(document).on('click', '[data-toggle="close-boss-button-overlay"]', function (e) {
            e.preventDefault();
            $('body').removeClass('show-boss-button-overlay');
            return false;
        });

        $(document).bind('keydown', function (e) {
            if (e.which === 27) {
                $('body').removeClass('show-boss-button-overlay');
            }
        });

    }

    window.BossButton = BossButton;
}());
